import React, { useEffect, useCallback } from "react";

import { BodyContainer } from "App/styles";

import { StepViewport, Step, StepContent } from "./styles";

import Form from "components/Form";
import { Topics } from "components/Topics";
import { Awards } from "components/Awards";
import { FormCreatedSuccessfully } from "components/FormFinalMessage";
import { Breadcrumb } from "components/Breadcrumb";
import { useTransition } from "react-spring";
import { MainTitle } from "components/MainTitle";

import useEntryFlow from "hooks/useFormFlow";
import useEntryForm from "hooks/useEntryForm";

export default function NewEntry() {
  const {
    topic,
    award,
    stepNumber,
    pageTitle,
    seoPageTitle,
    topicSelected,
    awardSelected,
    formCompleted,
    formReset,
  } = useEntryFlow();

  const { loadingForm, setUpNewForm, form } = useEntryForm();

  useEffect(() => {
    setUpNewForm(topic, award);

    return () => {};
  }, [award, setUpNewForm, topic]);

  const transitions = useTransition(stepNumber, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  // Cada item de la transición dibuja SU paso, no el paso actual. Mirando
  // `stepNumber` el paso que se está yendo renderiza el contenido del que
  // entra, y quedan las dos listas superpuestas a media opacidad.
  const renderStep = useCallback(
    (step) => {
      switch (step) {
        case 0: {
          return (
            <StepContent>
              <Topics onSelected={topicSelected} />
            </StepContent>
          );
        }
        case 1: {
          return (
            <StepContent>
              <Awards
                topic={topic}
                onBack={formReset}
                onSelected={awardSelected}
              />
            </StepContent>
          );
        }
        case 2: {
          return (
            <Form onCompleted={formCompleted} form={form} loading={loadingForm} />
          );
        }
        case 3: {
          return <FormCreatedSuccessfully />;
        }
        default: {
          return null;
        }
      }
    },
    [
      awardSelected,
      form,
      formCompleted,
      formReset,
      loadingForm,
      topic,
      topicSelected,
    ]
  );

  return (
    <React.Fragment>
      <BodyContainer>
        <Breadcrumb stepNumber={stepNumber} topic={topic} award={award} />

        <MainTitle title={pageTitle} seoTitle={seoPageTitle} />

        <StepViewport>
          {transitions((style, step) => (
            <Step style={style} $leaving={step !== stepNumber}>
              {renderStep(step)}
            </Step>
          ))}
        </StepViewport>
      </BodyContainer>
    </React.Fragment>
  );
}
